import { render, staticRenderFns } from "./CardShippingStatus.vue?vue&type=template&id=24e0d502"
import script from "./CardShippingStatus.vue?vue&type=script&lang=js"
export * from "./CardShippingStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports